module.exports = __webpack_public_path__ + "static/img/e6title.76f6eee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/e6title.png
// module id = pcqI
// module chunks = 0